<template>
  <div class="viewport viewport-with-top-nav viewport-compact" id="login-page">

    <TopNav></TopNav>

    <div class="display-1 py-4" id="login-page-header">{{ $t('LoginPage.title') }}</div>

    <p class="text-muted">{{ $t('LoginPage.messageForExistingCustomer') }}</p>

    <validation-observer ref="form">
      <div class="form-group">
        <validation-provider vid="pin" rules="pin" v-slot="{ errors }" mode="passive">
          <label for="loginPin">{{ $t('LoginPage.pin') }}</label>
          <input type="text"
                 id="loginPin"
                 class="form-control form-control-lg"
                 :class="{'is-invalid': errors.length}"
                 :disabled="loading"
                 :inputmode="getInputMode(mode)"
                 :placeholder="placeholder"
                 v-model.trim="pin"
                 v-focus
          >
          <span class="invalid-feedback">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <button id="button-login" class="btn btn-lg btn-primary btn-block" @click="onLoginClick" :disabled="loading">{{
          $t('LoginPage.logIn')
        }}
      </button>
    </validation-observer>

    <div class="small text-muted mt-4">
      <i18n path="LoginPage.fallbackMessage" tag="p">
        <template v-slot:fallbackLink>
          <router-link :to="{name: 'loan-form'}">{{ $t('LoginPage.fallbackLinkTitle') }}</router-link>
        </template>
      </i18n>
    </div>

    <div class="flex-grow-1"></div>

    <div class="dev-only mb-3 text-center" v-if="settings.isTestMode()">
      <button class="btn btn-xs btn-outline-secondary mock-value mr-2 mb-2" @click="pin = testPin" :key="index"
              v-for="(testPin, index) in testPins">{{ testPin }}
      </button>
    </div>
  </div>
</template>

<script>
import TopNav from '@shared/components/TopNav'
import store from '@shared/store'
import settings from '@shared/settings'
import UserMixin from '@shared/mixins/UserMixin'
import PinMixin from '@shared/mixins/PinMixin'

export default {
  name: 'LoginPage',
  components: { TopNav },
  props: ['placeholder', 'mode', 'testPins', 'initialPin'],
  data() {
    return {
      loading: false,
      pin: store.state.userPinForOTP || this.initialPin || '',
      settings: settings
    }
  },
  mixins: [UserMixin, PinMixin],
  mounted() {
    this.verifyMode(this.mode)
  },
  watch: {
    pin(newValue) {
      this.pin = this.sanitizeText(newValue, this.mode)
    }
  },
  methods: {
    onLoginClick() {
      this.$refs.form.validate().then((success) => {
        if (success) this.login()
      })
    },
    login() {
      this.loading = true
      store.setUserPinForOTP(this.pin)
      return this.signInRequest(this.pin).then(() => {
        this.$router.push({ name: 'otp' })
      }).catch(this.onValidationServerSideError)
    },
    onValidationServerSideError(error) {
      const response = error.response
      if (response && response.status === 400 && response.data) {
        const data = response.data
        if (data.fieldErrors) {
          this.handleFieldValidationErrors(data.fieldErrors)
        }
        if (data.errors) {
          this.handleGenericErrors(data.errors)
        }
      }
      this.loading = false
    },
    handleGenericErrors(errors) {
      errors.forEach(e => {
        this.$errorToast(this.$t(`errors.${e}.title`), this.$t(`errors.${e}.content`))
      })
    },
    handleFieldValidationErrors(fieldErrors) {
      this.$nextTick().then(() => {
        const errors = Object.entries(fieldErrors).reduce((accumulator, entry) => {
          accumulator[entry[0]] = entry[1].map(e => this.$t(`validation.${e}`))
          return accumulator
        }, {})

        this.$refs.form.setErrors(errors)
      })
    }
  }
}
</script>
